module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/main-visual@2x-efe8b99ddc8f0bd45a9fa51b6dbbea65.webp";